import {
  mapMutations
} from 'vuex'
import SockJS from "sockjs-client";
import Stomp from "stompjs";
export default {
  data() {
    return {
      noticeTimeOut: {},
      stompClientGlobal: null,
      stompClientPoint: null

    }
  },
  computed: {
    turntablegameAnnouncementConfig() {
      return this.$store.state.build10.config.turntablegameAnnouncementConfig;
    },

  },
  methods: {

    /**
     * 消息处理
     * @param {} message 
     */
    messagePushAll(message) {
      if (this.turntablegameAnnouncementConfig !== '1') return;
      switch (message.type) {
        case "301": // 开始转盘
          this.sendNotice(message);
          break;
        case "302": // 有人中奖
          message.msgContent = '恭喜' + message.byUsername + '在' + message.username + '直播间中奖' + message.giftName + '快来参加';
          this.sendNotice(message);
          break;
      }
    },
    /**
     * 收到更新跑马灯消息
     */
    sendNotice(content) {
      //收到消息后游戏内容设置，15s后消失
      this.$store.commit('SET_GAME_NOTICE', {
        msgContent: content.msgContent,
        roomId: content.roomId,
        roomNumber: content.roomNumber
      })
      clearTimeout(this.noticeTimeOut);
      this.noticeTimeOut = setTimeout(() => {
        this.$store.commit('SET_GAME_NOTICE', '')
      }, 15000)

    },
    /**
     * 初始全局跑马灯websocket
     */
    initNoticeSocket() {
      if(window.location.hash==='#/500?isShowRound=true') return;
      let httpIri = "";
      if (process.env.NODE_ENV === "development") {
        // 开发环境
        httpIri = "https://www.matpisa.com";
      } else {
        // 生产环境
        httpIri = window.location.origin;
      }
      const socketUrl = httpIri + "/api/guest/liveSocket";
      var ip = window.returnCitySN ? window.returnCitySN["cip"] : "";
      var domain = window.location.origin;
      // 添加消息提示
      console.log("正在连接弹幕服务器...");
      let socket = new SockJS(socketUrl);
      this.stompClientGlobal = Stomp.over(socket);
      this.stompClientGlobal.connect({
          pageType: "doMain",
          clientIp: ip,
          inDomain: domain,
        },
        (frame) => {
          console.log('链接成功');
          //所有直播间
          this.stompClientGlobal.subscribe(`/commonMsg/guest/getMsg`, (res) => {
            // 订阅服务器，接收消息
            let message = JSON.parse(res.body);
            this.messagePushAll(message);
            console.log(message)
          });
        },
        (err) => {
          // setTimeout(() => {
          //   this.initNoticeSocket();
          // }, 1000);
        }
      )
    },
    /**
     * 初始化打点websocket
     */
    initPointSocket() {
      let httpIri = "";
      if (process.env.NODE_ENV === "development") {
        // 开发环境
        httpIri = "https://www.matpisa.com";
      } else {
        // 生产环境
        httpIri = window.location.origin;
      }

      const socketUrl = httpIri + "/api/guest/pageReport";
      var ip = window.returnCitySN ? window.returnCitySN["cip"] : "";
      var domain = window.location.origin;
      var paramSessionId = sessionStorage.getItem("paramSessionId") || "";
      // 添加消息提示
      console.log("正在连接弹幕服务器...");
      let socket = new SockJS(socketUrl);
      this.stompClientPoint = Stomp.over(socket);
      this.stompClientPoint.connect({
          pageType: "doMain",
          clientIp: ip,
          inDomain: domain,
          paramSessionId: paramSessionId,
        },
        (frame) => {
          console.log('链接成功')
        },
        (err) => {
          setTimeout(() => {
            this.initPointSocket();
          }, 1000);
        }
      )
    }

  },
  mounted() {
    this.initNoticeSocket(); //全局长连接
    let loadTime = sessionStorage.getItem("loadTime"); //获取落地页带来的渲染时间戳，如果存在且合现在时间在24消失以内则有效
    let nowTime = new Date().getTime();
    if (loadTime && Number(loadTime) - Number(nowTime) < nowTime) {
      this.$store.commit("SET_LOAD_LUODIYE", true);
      this.initPointSocket();
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/build08/mixin/global-sock.js